import Vuex from 'vuex';
import Vue from 'vue';
import scenarios from './modules/scenarios';
import auth from './modules/auth';
import createPersist, { createStorage } from 'vuex-localstorage';
import * as types from './types';

import Api from '../api/Api';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        unit: 'si',
        motor_types: [],
        settings: [],
    },
    getters: {
        getUnits(state) {
            return state.scenarios.unit_profiles;
        },
        getActiveUnit(state) {
            return state.unit;
        },
        getMotorTypes(state) {
            return state.motor_types;
        },
        getMotorType: state => type => {
            return state.motor_types.find(
                motor => motor.name.toLowerCase().replace(/ /g, '-') === type.replace(/ /g, '-'),
            );
        },
        getMotorTypeById: state => id => {
            if (state.motor_types === undefined) {
                return undefined;
            }

            return state.motor_types.find(motor => motor.id === id);
        },
    },
    actions: {
        changeUnit(context, unit) {
            if (unit.indexOf('(') > -1) {
                localStorage.setItem('torque_unit', unit);
            } else {
                localStorage.setItem('unit', unit);
            }

            context.commit(types.CHANGE_UNIT, {
                unit,
            });
        },
        getUnitFromLocalStorage(context) {
            let unit = localStorage.getItem('unit');
            if (unit === undefined || unit === 'undefined') {
                unit = 'si';
            }

            context.commit(types.CHANGE_UNIT, {
                unit: unit,
            });
        },
        fetchMotorTypes(context) {
            let req = Vue.api.get('/series/');
            req.send()
                .then(types => {
                    context.commit('SET_MOTOR_TYPES', { types: types });
                })
                .catch(err => {
                    console.warn('Motor types fetch error', err);
                });
        },
        getSettingsFromLocalStorage(context) {
            let settings = localStorage.getItem('settings');
            if (settings) {
                context.commit('SET_SETTINGS', { settings: JSON.parse(settings) });
            }
        },
        async fetchSettings(context) {
            await Vue.api
                .get('/settings/')
                .send()
                .then(settings => {
                    console.log('[ settings ] Fetch settings from api', settings);
                    localStorage.setItem('settings', JSON.stringify(settings));
                })
                .catch(err => {
                    console.warn('[ settings ] Settings fetch error', err);
                });
        },
    },
    mutations: {
        [types.CHANGE_UNIT](state, { unit }) {
            state.unit = unit;
        },
        SET_MOTOR_TYPES(state, { types }) {
            if (types === undefined) {
                types = [];
            }

            state.motor_types = types;

        },
        SET_SETTINGS(state, { settings }) {
            state.settings = settings;
        },
    },
    modules: {
        scenarios,
        auth,
    },
});

export default store;
